import React, { useState,useEffect,useCallback } from 'react';
import Button from 'carbon-components-react/lib/components/Button';
import  Automation  from 'assets/image/Automation_Leadspaces_FINAL_RPA.svg';
import i18n from "../../i18n";
import { useHistory } from 'react-router-dom';

require("./_add-new-code.scss");


const AddNewCodePage = props => {
   

  useEffect(() => {
    

  }, []);
  const codeAdded = i18n.t('qualityCode.codeAdded');
  const statusCheck = i18n.t('qualityCode.statusCheck');
  const buttonCheck = i18n.t('qualityCode.buttonCheck');
  const history = useHistory();

  return (
      <div className="page-margin padding-top-30px">
        
        <div className="add-new-code-page-margin">
        <div className="add-new-main">
            <div className= "add-new-main-segment-image"><img src={Automation} alt="" /></div>
           {/* <div className="vertical-divider"></div> */}
            <div className="add-new-main-segment">
                  <ul className="add-new-main-segment-heading">{codeAdded}</ul>
                  <ul className="add-new-main-segment-heading">{props.location.request_no}</ul>
                  <ul>{statusCheck}</ul>
                  <ul><Button className="add-new-main-segment-button" kind="tertiary" onClick={() => history.push('/qualityCheck')} >{buttonCheck}</Button></ul>
            </div>
         </div>
         </div>
         </div>
      );
}
export default AddNewCodePage